// http 로 연 화면(localhost 가 아닌 주소)에는 navigator.clipboard 가 없다 — 숨긴 입력 칸으로 복사한다
function copyText ( text ) {

    if ( navigator.clipboard ) {

        return navigator.clipboard.writeText ( text );

    }

    const input = document.createElement ( "textarea" );

    input.value = text;
    document.body.appendChild ( input );
    input.select ();
    document.execCommand ( "copy" );
    document.body.removeChild ( input );

}

export default copyText;
